import classNames from "classnames";

import {AnalyzerUserMessageProps} from "@/pages/analyzer/Analyzer.types.ts";

import styles from "./AnalyzerUserMessage.module.scss";

export const AnalyzerUserMessage = ({content, className}: AnalyzerUserMessageProps) => (
  <div className={classNames(styles.userMessage, className)}>
    <div className={styles.bubble}>{content}</div>
  </div>
);
